import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/$locale/_authenticated/gear-erp/validation')({
  validateSearch: z.object({ contract: z.string().optional() }),
  beforeLoad: ({ params, search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/$locale/erp-sync/readiness',
      params: { locale: params.locale },
      search,
    });
  },
});
